/** @format */

import { useGetJobMeCompany } from "../../../../api/queries/job.query";
import All from "./all_candidate";
import Cancelled from "./cancelled_candidate";
import Hired from "./hired_candidate";
import New from "./new_candidate";
import Rejected from "./rejected_candidate";
import Shortlisted from "./shortlisted_candidate";
import background from "src/assets/images/9926.jpg";

const { CardBody, Card, Container, Tab, Nav } = require("react-bootstrap");

const Candidate = () => {
  const { data: jobData, isLoading: isLoadingJobData } = useGetJobMeCompany({
    select: (response) => response.data.company,
  });

  return (
    <div
      id="content-page"
      className="content-inner"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        overflowY: "auto",
      }}
    >
      <Container>
        <Card>
          {isLoadingJobData ? (
            <h2>Loading...</h2>
          ) : jobData && jobData.company ? (
            jobData.company.map((job) => (
              <CardBody>
                <div className="d-flex align-items-center justify-content-between">
                  <h2 className="mb-0 me-3">{job.account_id}</h2>
                  <div className="d-flex align-items-center">
                    <i className="icon material-symbols-outlined me-2">share</i>
                    <h6 className="mb-0">Share</h6>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex justify-content-between">
                    <span className="material-symbols-outlined me-2">
                      calendar_month
                    </span>
                    <h6 className="mb-0">Job Posted: 18/09/2024</h6>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <span className="material-symbols-outlined me-2">
                      calendar_month
                    </span>
                    <h6 className="mb-0">Expires: 18/10/2024</h6>
                  </div>
                  <div className="d-flex align-items-center mt-3">
                    <button className="btn btn-primary me-4">Repost</button>
                    <button className="btn btn-primary">Edit</button>
                  </div>
                </div>
              </CardBody>
            ))
          ) : (
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-lg-4">
                  <Card className=" mt-2">
                    <h2 className="p-3">All Jobs</h2>
                  </Card>
                </div>
              </div>
            </div>
          )}

          <hr />
          <CardBody>
            <h2>Total Applicants</h2>
            <Card>
              <Card.Body>
                <Tab.Container defaultActiveKey="all">
                  <Nav variant="tabs" id="nav-tab" role="tablist" as={"ul"}>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="all"
                        id="nav-home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-home"
                        type="button"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                      >
                        All
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="new"
                        id="nav-profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-profile"
                        type="button"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="true"
                      >
                        New
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="cancelled"
                        id="nav-contact-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-contact"
                        type="button"
                        role="tab"
                        aria-controls="nav-contact"
                        aria-selected="true"
                      >
                        Cancelled
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="rejected"
                        id="nav-rejected-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-rejected"
                        type="button"
                        role="tab"
                        aria-controls="nav-rejected"
                        aria-selected="true"
                      >
                        Rejected
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="shortlisted"
                        id="nav-shortlisted-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-shortlisted"
                        type="button"
                        role="tab"
                        aria-controls="nav-shortlisted"
                        aria-selected="true"
                      >
                        Shortlisted
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="hired"
                        id="nav-hired-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-hired"
                        type="button"
                        role="tab"
                        aria-controls="nav-hired"
                        aria-selected="true"
                      >
                        Hired
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>

                  <Tab.Content>
                    <Tab.Pane
                      eventKey="all"
                      id="nav-home"
                      role="tabpanel"
                      aria-labelledby="nav-home-tab"
                    >
                      <p>
                        <All />
                      </p>
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="new"
                      id="nav-profile"
                      role="tabpanel"
                      aria-labelledby="nav-profile-tab"
                    >
                      <New />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="cancelled"
                      id="nav-contact"
                      role="tabpanel"
                      aria-labelledby="nav-contact-tab"
                    >
                      <Cancelled />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="rejected"
                      id="nav-rejected"
                      role="tabpanel"
                      aria-labelledby="nav-rejected-tab"
                    >
                      <Rejected />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="shortlisted"
                      id="nav-shortlisted"
                      role="tabpanel"
                      aria-labelledby="nav-shortlisted-tab"
                    >
                      <Shortlisted />
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="hired"
                      id="nav-hired"
                      role="tabpanel"
                      aria-labelledby="nav-hired-tab"
                    >
                      <Hired />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default Candidate;
